import { render } from "./index.vue?vue&type=template&id=22bb68fc&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=22bb68fc&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.38_typescript@5.9.3__webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bb68fc"]])

export default __exports__